import { createAction, props } from '@ngrx/store';

/**
 * Dispatched by `ConfigService.init()` before the backend load, to rehydrate the slice from
 * the persisted cache (via the generic persistence layer) so config is available offline.
 */
export const initConfig = createAction('[Config] Init');

/**
 * Dispatched once the backend config has been loaded (from ConfigService.init()). Populates the
 * slice and triggers a persist of the slice to storage.
 */
export const configLoaded = createAction('[Config] Loaded', props<{ configValues: Record<string, string> }>());

/**
 * Dispatched by the persistence bridge with the config read back from storage. Populates the
 * slice like {@link configLoaded} but does not trigger a re-persist (the data came from storage).
 */
export const configLoadedFromStorage = createAction(
    '[Config] Loaded from storage',
    props<{ configValues: Record<string, string> }>(),
);

/**
 * Dispatched by the load effect when the backend request fails. Transitions the slice to
 * {@link LoadStatus.Error} so the facade's `init()` observable can surface the failure.
 */
export const configFailed = createAction('[Config] Failed');
